import React, { useEffect } from 'react';

import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider,
} from "react-router-dom";

import { config } from "@fortawesome/fontawesome-svg-core";

import AppRoot from '@refere/ui-utils/ui/components/AppRoot';
import OnLoader from '@refere/ui-utils/ui/components/OnLoader';
import { setErrorCallBack } from '@refere/ui-utils/ui/utils/fetch';

import { init } from "./features/app";

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

import { theme } from './theme';
import LojaPage from './pages/loja/LojaPage';
import PropostaPage from './pages/proposta/PropostaPage';

import { useHookstate } from '@hookstate/core';

import globalState from './features/global-state';

//necessário para forçar o uso do css dele, setado na página raiz
config.autoAddCss = false;

const nonceTag = document.getElementById("nonce") as HTMLInputElement | null;
const nonce = nonceTag.value;
const cache = createCache({
     key: 'refere-sistema',
     nonce,
     prepend: true,
});

export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path='/' element={<OnLoader />} />
            <Route path='/loja' element={<LojaPage />} />
            <Route path='/proposta' element={<PropostaPage />} />
        </>
    )
  );

export const App = () => {
    const isLoading = useHookstate(globalState.isLoading);

    useEffect(() => {
        init();
    }, []);

    return (
        <CacheProvider value={cache}>
            <AppRoot 
                theme={theme}
                isLoading={
                    isLoading.get({noproxy:true})
                }
                setFetchErrorCallBack={setErrorCallBack}
                onFetchError={() => globalState.isLoading.set(false)}
            >
                <RouterProvider router={router} />
            </AppRoot>
        </CacheProvider>
        
    );
};

export default App
